import { Outlet } from "react-router-dom";
import SideNavigation from "../side-navigation";
import PageHeaderRenderer from "../page-header-renderer";
import MobileNavigation from "../mobile-navigation";
import SelectedRowsOperator from "../selected-rows-operator";

const DashboardLayout = () => {
  return (
    <div className="flex h-screen border">
      <SideNavigation />
      <main className="flex-1 flex flex-col h-full min-w-0">
        <div className="py-3 sm:py-4 px-3 border-b flex items-center gap-2">
          <MobileNavigation />
          <PageHeaderRenderer />
        </div>
        <div className="flex-1 overflow-scroll">
          <Outlet />
        </div>
      </main>
      <SelectedRowsOperator />
    </div>
  );
};

export default DashboardLayout;
